<template>
    <v-container grid-list-md class="fb-rip-account-create-process">
        <v-layout row wrap>
            <v-flex md10>
                <v-form ref="form_fb_rip_account">
                    
                    <!--linkOrId-->
                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Link hoặc ID trang cá nhân cần rip:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                solo
                                v-model="linkOrId"
                                required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <!--videoRef-->
                    <v-layout align-center row v-if="videoId">
                        <v-flex offset-md4>
                            <div class="v-sheet theme--light explain">
                                <a href="#videoRef">
                                    <span class="blue_text label-highlight">Video hướng dẫn tạo job</span>
                                </a>
                            </div>
                        </v-flex>
                    </v-layout>

                    <!--typeRip-->
                    <v-layout v-if="types.length > 0" align-center row>
                        <v-flex md4>
                            <label class="text-color">Loại rip:</label>
                        </v-flex>
                        <v-flex md8 pt-6>
                            <label v-for="item in types"
                                   :key="item.value"
                                   class="answer-radio-container">
                                <input :value="item.value"
                                       :key="item.value"
                                       v-model="type"
                                       type="radio"
                                       v-if="item.value !== '2'">
                                <span v-if="item.value !== '2'">
                                    {{ item.text }}
                                </span>
                                <br>
                            </label>
                        </v-flex>
                    </v-layout>

                    <!--throughHand-->
                    <v-layout v-if="throughHands.length > 0" align-center row>
                        <v-flex md4>
                            <label class="text-color">Qua tay hay chưa:</label>
                        </v-flex>
                        <v-flex md8 pt-6>
                            <label v-for="item in throughHands"
                                   :key="item.value"
                                   class="answer-radio-container">
                                <input :value="item.value"
                                       :key="item.value"
                                       v-model="throughHand"
                                       type="radio">
                                {{ item.text }} <br>
                            </label>
                        </v-flex>
                    </v-layout>

                    <!--yearAccountCreation-->
                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Năm tạo nick: </label>
                        </v-flex>
                        <v-flex md8 pt-6>
                            <v-select
                                solo
                                :items="yearAccountCreations"
                                v-model="yearAccountCreation"
                                item-text="text"
                                item-value="value">
                            </v-select>
                        </v-flex>
                    </v-layout>

                    <!--contactFone-->
                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Số điện thoại liên hệ (có vấn đề bên admin sẽ thông báo):</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                solo
                                :counter="11"
                                required
                                type="number"
                                v-model="contactFone"
                                placeholder="Nhập số điện thoại"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <!--contactFb-->
                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Link Facebook liên hệ (có vấn đề bên admin sẽ thông báo):</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                solo
                                v-model="contactFb"
                                placeholder="Nhập link facebook"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <!--price-->
                    <v-layout align-center row>
                        <v-flex md4>
                            <label class="text-color">Giá tiền rip acc:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                solo
                                v-model="price"
                                type="number"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <!--notePrice-->
                    <v-layout align-center row>
                        <v-flex offset-md4>
                            <div class="v-sheet theme--light explain">
                                <span>HÃY ĐỌC ĐỂ TRÁNH MẤT TIỀN KHI SỬ DỤNG!</span><br>
                                <span class="red_text">Thời gian xử lí RIP từ 12h - 7 ngày nếu không RIP được chúng tôi sẽ hoàn tiền về tài khoản luôn!</span>
                            </div>
                        </v-flex>
                    </v-layout>

                    <!--note-->
                    <v-layout align-center row>
                        <v-flex md4>
                            <label class="text-color">Ghi chú:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-textarea
                                solo
                                v-model="notes"
                                placeholder="Nhập nội dung ghi chú về tiến trình của bạn"
                                height="100px"
                            ></v-textarea>
                        </v-flex>
                    </v-layout>

                </v-form>

                <v-layout align-center row>
                    <v-flex md12>
                        <v-card :color="COLOR.CLICK_MENU_COLOR" height="100px">
                            <v-card-title>
                                <div class="div-total">
                                    <p>
                                        Tổng: <strong>{{totalCoin | currency_init}}</strong> Coin <br>
                                        Giá <strong class="green--text">{{price | currency_init}}</strong> Coin / 1 lần
                                    </p>
                                </div>

                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout align-center row>
                    <v-flex md12>
                        <v-btn width="100%" height="50px" :color="COLOR.MAIN_COLOR" class="white--text"
                               @click="saveProcess">
                            Tạo tiến trình
                        </v-btn>
                    </v-flex>
                </v-layout>
                
                <!--video youtube-->
                <v-layout align-center row v-if="videoId" id="videoRef">
                    <v-flex md12>
                        <div class="col-sm-12 mb-n3">
                            <h3 class="text-color">HƯỚNG DẪN SỬ DỤNG</h3>
                        </div>
                        <div class="col-sm-12 mb-n3">
                            <youtube :video-id="videoId" ref="youtube"
                                 @buffering="playing"
                                 @paused="paused"
                                 @ended="paused"
                                 @playing="playing"
                                 width="100%" height="650px">
                            </youtube>
                        </div>
                    </v-flex>
                </v-layout>

            </v-flex>
        </v-layout>
        <v-overlay :value="overlay">
            <v-progress-circular
                indeterminate
                color="info"
            ></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
    import {COLOR, SEEDING} from "~/config/constant";
    import {validURLFb} from "../../common/helper.string";
    import Swal from 'sweetalert2';
    import {
        FB_RIP_ACCOUNT_HISTORY,
        FB_POST_GET_LIST_SEEDING,
        FB_GET_PROFILE_ID_BUFF,
        FB_RIP_ACCOUNT_SAVE_PROCESS
    } from "~/store/actions.type";
    import {formatCurrency} from "~/common/helper.string";

    import $ from 'jquery';

    export default {
        name: "FbRipAccountCreateProcess",
        components: {
        },
        data() {
            return {
                overlay: false,
                // Color chinh
                COLOR: COLOR,
                SEEDING: SEEDING,

                types: [],
                type: 1,
                throughHands: [],
                throughHand: 1,
                yearAccountCreations: [],
                yearAccountCreation: 1,
                contactFone: '',
                contactFb: '',

                typeSeeding: 30,
                price: 0,
                priceMin: 0,

                totalCoin: 0,

                notes: '',
                
                // Link hoac ID ca nhan
                linkOrId: "",
                linkOrIdClone: "",

                listSeedingApi: [],
                videoId: '',
                videoStatus: true,
                ripAccountHistory: [],
            }
        },
        watch: {
            linkOrId(){
                this.linkOrIdClone = this.linkOrId;
                if (validURLFb(this.linkOrId, 'facebook')) {
                    this.getPostId();
                }
            },
            price() {
                this.calculate();
            }
        },
        mounted() {
            this.customDataFromApi();
            if ($('.menu-fb-buff').parent().attr('aria-expanded') == "false") {
                $('.menu-fb-buff').click();
            }
        },
        methods: {
            async getPostId() {
                let data  =  await this.$store.dispatch(FB_GET_PROFILE_ID_BUFF, {facebook_link: this.linkOrId});
                if (data) {
                    this.linkOrId = data +'';
                }

            },
            async customDataFromApi() {
                this.listSeedingApi = await this.$store.dispatch(FB_POST_GET_LIST_SEEDING);
                let data = await this.$store.dispatch(FB_RIP_ACCOUNT_HISTORY);

                this.yearAccountCreations = data['yearAccountCreations']
                this.yearAccountCreation = data['yearAccountCreations'][0].value
                
                for (let i = 0; i < Object.values(data.types).length; i++) {
                    this.types.push({
                        text: Object.values(data.types)[i],
                        value: Object.keys(data.types)[i]
                    });
                }

                for (let i = 0; i < Object.values(data.throughHands).length; i++) {
                    this.throughHands.push({
                        text: Object.values(data.throughHands)[i],
                        value: Object.keys(data.throughHands)[i]
                    });
                }

                for (let i = 0; i < this.listSeedingApi.length; i++) {
                    if (this.listSeedingApi[i].type === 'fb_rip_account') {
                        if (this.listSeedingApi[i].video) {
                            let videoId = this.youtube_parser(this.listSeedingApi[i].video);
                            if (videoId) {
                                this.videoId = videoId;
                            }
                        }
                    }
                }

                this.initDefault();
            },
            initDefault() {

                this.price = this.price ? this.price : this.listSeedingApi[this.typeSeeding - 1].fix_coin;
                this.priceMin = this.priceMin ? this.priceMin : this.listSeedingApi[this.typeSeeding - 1].fix_coin;
                
                this.calculate();
            },
            validateForm() {
                let valid = true;
                
                if (this.linkOrId.trim() === '') {
                    return {check: false, message: "Vui lòng nhập Link hoặc ID trang cá nhân"};
                }

                if (this.contactFone.trim() === '') {
                    return {check: false, message: "Vui lòng nhập Số điện thoại liên hệ"};
                }

                if (this.contactFone.trim().length < 10
                || this.contactFone.trim().length > 11) {
                    return {check: false, message: "Số điện thoại trong khoản 10-11 ký tự"};
                }
                
                if (!validURLFb(this.linkOrIdClone, 'facebook')) {
                    return {check: false, message: "Link fb không hợp lệ"};
                }
                
                return {check: valid, message: ""};
            },
            validatePrice() {
                let valid = true;
                if (this.price < this.priceMin) {
                    return {checkValidatePrice: false, message: 'Giá thấp nhất là '+this.priceMin+' coin'}
                }
                return {checkValidatePrice: valid, message: ''}
            },
            getParams() {
                let params = {
                    fb_link: this.linkOrIdClone,
                    type: this.type,
                    through_hands: this.throughHand,
                    year_account_creation: this.yearAccountCreation,
                    note: this.notes,
                    contact_fb: this.contactFb,
                    contact_fone: this.contactFone,
                    price: this.totalCoin
                };
                return params;
            },
            async saveProcess() {
                this.calculate();
                let validateForm = this.validateForm();
                let validatePrice = this.validatePrice();
                if (validateForm.check) {
                    if (!validatePrice.checkValidatePrice) {
                        Swal.fire(
                            validatePrice.message,
                            '...',
                            'error'
                        )
                    } else {
                        try {
                            Swal.fire({
                                title: 'Xác nhận',
                                text: "Bạn có chắc chắn muốn mua Giá "+formatCurrency(parseInt(this.price))+" Coin / 1 lần?",
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Đồng ý!',
                                cancelButtonText: 'Không'
                            }).then((result) => {
                                if (result.value) {
                                    this.overlay = true;
                                    this.saveProcessApi();
                                }
                            })
                        } catch (error) {
                            console.log(error);
                        }
                    }
                } else {
                    Swal.fire(
                        validateForm.message,
                        '...',
                        'error'
                    )
                }
            },
            async saveProcessApi() {
                let check = await this.$store.dispatch(FB_RIP_ACCOUNT_SAVE_PROCESS, this.getParams());
                if (check) {
                    this.overlay = false;
                    this.$router.go();
                } else {
                    this.overlay = false;
                }


            },
            async calculate() {
                this.totalCoin = this.price;
            },

            playing() {
                this.videoStatus = false;
            },
            paused() {
                this.videoStatus = true;
            },
            youtube_parser(url) {
                let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                let match = url.match(regExp);
                return (match && match[7].length == 11) ? match[7] : false;
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/main";

    .fb-rip-account-create-process {
        background-color: $bgMainColor;
        max-width: 100% !important;

        .v-text-field__details {
            display: none;
        }

        .text-color {
            color: $mainColor;
            font-weight: bold;
        }

        .div-total {
            width: 100%;
            color: white;
            text-align: center;
        }

        .div-cx {
            height: 60px;

            .cx-img {
                cursor: pointer;

                &hover {
                    opacity: 0.8;
                }
            }

            .cxSelected {
                height: 60px;
                width: 60px;
            }
        }
    }
</style>
